import { gql } from "@apollo/client";

/**
 * SLA status of the asset's IoT connection (IBM-1045 / IBM-1041), in
 * isolation. `slaInformation` is declared non-null, but the IoT resolver
 * returns null for connections without an SLA record — the error then nulls
 * the WHOLE iotConnection (same failure mode as `iotHubConnectivityStatus`).
 * So the field must never share a selection with connectionStatus/id
 * consumers (never in AssetDashboardHero), and every consumer uses
 * fetchPolicy "no-cache" + errorPolicy "all" so a nulled iotConnection can't
 * clobber the cached connection of the other queries. Only sent while
 * REACT_APP_ENABLE_SLA is on (callers `skip` otherwise).
 */
export const AssetIoTSlaStatus = gql`
  query AssetIoTSlaStatus($id: ID!) {
    assetLocation(id: $id) {
      id
      iotConnection {
        id
        slaInformation {
          status
          level
          connectivityQuality
        }
      }
    }
  }
`;
